import {CommandClause, CPCLCommand} from "@psdk/frame-father";
import {BasicCPCLArg} from "./basic";
import {CFont, CRotation} from "../types";

export class CText extends BasicCPCLArg<CText> {
  public x: number;
  public y: number;
  private content: string;
  private readonly font: CFont;
  private rotation: CRotation;
  private charset: string;
  constructor(options?: {
    /**
     * 起始横坐标
     */
    x?: number
    /**
     * 起始纵坐标
     */
    y?: number
    /**
     * 条码内容
     */
    content?: string
    /**
     * 字体
     */
    font?: CFont
    /**
     * 旋转
     */
    rotation?: CRotation
    /**
     * 编码
     */
    charset?: string

  }) {
    super();
    this.x = options?.x ?? 0;
    this.y = options?.y ?? 0;
    this.content = options?.content ?? '';
    this.font = options?.font ?? CFont.TSS16;
    this.rotation = options?.rotation ?? CRotation.ROTATION_0;
    this.charset = options?.charset ?? 'gbk';
  }

  clause(): CommandClause {
    let fontEntity;
    switch (this.font) {
      case CFont.TSS16:
        fontEntity = new FontEntity(1, 1, 55, 0, 16);
        break;
      case CFont.TSS20:
        fontEntity = new FontEntity(1, 1, 6, 0, 20);
        break;
      case CFont.TSS20_MAX1:
        fontEntity = new FontEntity(1, 1, 6, 0, 40);
        break;
      case CFont.TSS24:
        fontEntity = new FontEntity(2, 2, 24, 0, 24);
        break;
      case CFont.TSS32:
        fontEntity = new FontEntity(1, 1, 4, 0, 32);
        break;
      case CFont.TSS24_MAX1:
        fontEntity = new FontEntity(2, 2, 24, 0, 48);
        break;
      case CFont.TSS24_MAX2:
        fontEntity = new FontEntity(3, 3, 24, 0, 72);
        break;
      case CFont.TSS28_MAX1:
        fontEntity = new FontEntity(1, 1, 7, 3, 56);
        break;
      case CFont.TSS32_MAX1:
        fontEntity = new FontEntity(2, 2, 4, 0, 64);
        break;
      case CFont.TSS32_MAX2:
        fontEntity = new FontEntity(3, 3, 4, 0, 96);
        break;
    }

    return CPCLCommand.with(this.header(),this.charset)
      .appendNumber(fontEntity.family)
      .appendNumber(fontEntity.size)
      .appendNumber(this.x)
      .appendNumber(this.y)
      .appendText(this.content)
      .clause();

  }

  header(): string {
    return 'T' + this.rotation;
  }

}

class FontEntity {
  ex: number;
  ey: number;
  family: number;
  size: number;
  height: number;

  constructor(ex, ey, family, size, height) {
    this.ex = ex;
    this.ey = ey;
    this.family = family;
    this.size = size;
    this.height = height;
  }
}
